import script from "./FeedV2Element.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FeedV2Element.vue?vue&type=script&lang=js"
export * from "./FeedV2Element.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./FeedV2Element.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/dynamic-app-elements/display/FeedV2Element.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d7a237da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d7a237da', __exports__)) {
    api.reload('d7a237da', __exports__)
  }
  
}


export default __exports__